import React from "react";
import { Link } from "react-router-dom";
import { Zap } from "lucide-react";
import { TextQuoteButton } from "./TextQuoteButton";
import { useContent, fill } from "../../lib/content";

export const OfferHero = () => {
  const c = useContent();
  const h = c.hero;
  const ph = c.photos.hero;
  return (
  <section data-testid="offer-hero" className="relative overflow-hidden bg-[#06142e] text-white">
    <div className="relative max-w-[1280px] mx-auto px-5 lg:px-8 py-16 md:py-24 grid lg:grid-cols-[1.1fr_1fr] gap-12 items-center">
      <div>
      <p className="text-[#3b9dff] font-semibold tracking-widest uppercase text-xs animate-fade-up">{h.eyebrow}</p>
      <h1 data-testid="offer-hero-title" className="mt-5 max-w-3xl text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05]">
        {h.title}
      </h1>
      <p className="mt-6 max-w-2xl text-lg md:text-xl text-slate-200 leading-relaxed">
        {h.subtitle}
      </p>
      <ul className="mt-8 flex flex-wrap gap-2">
        {h.chips.map((s, i) => (
          <li key={s} className="px-3 py-1.5 rounded-full bg-white/10 border border-white/15 text-sm backdrop-blur" style={{ animationDelay: `${i * 80}ms` }}>
            {s}
          </li>
        ))}
      </ul>
      <div className="mt-10 flex flex-wrap items-center gap-3">
        <TextQuoteButton testId="hero-text-quote-btn" label={fill(h.ctaLabel, c)} />
        <Link to="/tv-mounting-quote" data-testid="hero-instant-quote-btn" className="inline-flex items-center gap-2 px-7 py-4 rounded-full border-2 border-white/30 text-white font-bold text-base md:text-lg hover:bg-white/10 transition-colors">
          <Zap className="w-5 h-5 text-[#3b9dff]" /> Instant Quote
        </Link>
      </div>
      <a href="#photo-quote" data-testid="hero-upload-link" className="mt-4 block text-sm text-slate-300 underline underline-offset-4 hover:text-white">On a computer? Upload a photo instead</a>
      </div>
      <figure className="relative">
        <img src={ph.src} alt={ph.alt} data-testid="hero-install-photo" className="w-full aspect-square object-cover rounded-3xl shadow-2xl ring-1 ring-white/10" />
        {ph.caption && <figcaption className="absolute bottom-4 left-4 px-3 py-1.5 rounded-full bg-[#06142e]/80 backdrop-blur text-xs font-semibold">{ph.caption}</figcaption>}
      </figure>
    </div>
  </section>
  );
};
